'use client'

import { useTranslations } from 'next-intl'

import type { ModelsPlatformStatsResponse } from '@/api/generated-api'
import HeroStatsBand from '@/app/[locale]/components/HeroStatsBand'
import { formatStatValue } from '@/features/stats/format'
import { usePlatformStats } from '@/features/stats/hooks'

const FALLBACK = {
  fans: '50k+',
  countries: '20+',
  challenges: '500+',
  arenaPoints: '500k+'
}

const FansStatsBar = ({
  initialStats
}: {
  initialStats?: ModelsPlatformStatsResponse
}) => {
  const t = useTranslations('fansPage.hero')
  const { data } = usePlatformStats(initialStats)

  const items = [
    {
      value: data ? formatStatValue(data.active_fans_count) : FALLBACK.fans,
      captionLines: [t('bandActive'), t('bandFans')]
    },
    {
      value: data ? formatStatValue(data.countries_count) : FALLBACK.countries,
      captionLines: [t('bandCountriesTop'), t('bandCountriesBottom')]
    },
    {
      value: data
        ? formatStatValue(data.completed_challenges_count)
        : FALLBACK.challenges,
      captionLines: [t('bandChallengesTop'), t('bandChallengesBottom')]
    },
    {
      value: data
        ? formatStatValue(data.total_arena_points)
        : FALLBACK.arenaPoints,
      captionLines: [t('bandArenaPointsTop'), t('bandArenaPointsBottom')]
    }
  ]

  return <HeroStatsBand items={items} variant="fans" />
}

export default FansStatsBar
